<template>
  <div
    class="card"
    @click="handleClickEvent"
  >
    <div
      v-if="title"
      class="card-header"
    >
      {{ title }}
    </div>

    <div
      class="card-body"
      v-bind="cardBodyProps"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    title: { type: String, default: null },
    cardBodyProps: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    handleClickEvent () {
      this.$emit('click')
    }
  }
}
</script>
